import React from "react";
import LoginHeader from "./LoginHeader";
import LoginContent from "./LoginContent";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 12,
    maxWidth: 450,
    textAlign: "center",
  },
  header: {
    textAlign: "center",
    spacing: 10,
  },
}));

const LoginCard = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Card className={classes.root} elevation={0}>
      <LoginHeader
        tabNumber={value}
        change={handleChange}
        className={classes.header}
      />
      <Divider variant="middle" />
      <CardContent>
        <LoginContent tabNumber={value} />
      </CardContent>
    </Card>
  );
};

export default LoginCard;
